import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import NoAccessPage from "../../../components/NoAccess";
import { useAppStore } from "../../../store";
import { memo, useEffect, useState } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Access = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
    layoutConfig = _ref.layoutConfig,
    route = _ref.route;
  var flatPathRoutes = useAppStore(function (s) {
    return s.flatPathRoutes;
  });
  var menus = useAppStore(function (s) {
    return s.menus;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showNoAccessPage = _useState2[0],
    setShowNoAccessPage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    show = _useState4[0],
    setShow = _useState4[1];
  var NoAccessPageFallback = layoutConfig.noAccessFallback ? /*#__PURE__*/_jsx(_Fragment, {
    children: layoutConfig.noAccessFallback(route, layoutConfig)
  }) : /*#__PURE__*/_jsx(NoAccessPage, {});
  var canAccess = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (layoutConfig.canAccess) {
              _context.next = 3;
              break;
            }
            setShow(true);
            return _context.abrupt("return");
          case 3:
            _context.next = 5;
            return layoutConfig.canAccess({
              route: route,
              routes: flatPathRoutes,
              menus: menus
            });
          case 5:
            res = _context.sent;
            setShowNoAccessPage(!res);
            setShow(true);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function canAccess() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    canAccess();
  }, []);
  if (!show) {
    return null;
  }
  if (showNoAccessPage) {
    return NoAccessPageFallback;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
});
export default Access;